import * as curlconverter from 'curlconverter';

const HLJS_LANG = {
    ansible: 'yaml',
    c: 'c',
    cfml: 'php',
    clojure: 'clojure',
    csharp: 'csharp',
    dart: 'dart',
    elixir: 'elixir',
    go: 'go',
    har: 'json',
    httpie: 'bash',
    java: 'java',
    'java-httpurlconnection': 'java',
    'java-jsoup': 'java',
    'java-okhttp': 'java',
    javascript: 'javascript',
    'javascript-jquery': 'javascript',
    'javascript-xhr': 'javascript',
    julia: 'julia',
    kotlin: 'kotlin',
    lua: 'lua',
    matlab: 'matlab',
    node: 'javascript',
    'node-http': 'javascript',
    'node-axios': 'javascript',
    'node-got': 'javascript',
    'node-ky': 'javascript',
    'node-request': 'javascript',
    'node-superagent': 'javascript',
    objc: 'objectivec',
    ocaml: 'ocaml',
    perl: 'perl',
    php: 'php',
    'php-guzzle': 'php',
    'php-requests': 'php',
    powershell: 'powershell',
    'powershell-webrequest': 'powershell',
    python: 'python',
    'python-http': 'python',
    r: 'r',
    'r-httr2': 'r',
    ruby: 'ruby',
    'ruby-httparty': 'ruby',
    rust: 'rust',
    swift: 'swift',
};

const CONVERTERS = {
    ansible: curlconverter.toAnsibleWarn,
    c: curlconverter.toCWarn,
    cfml: curlconverter.toCFMLWarn,
    clojure: curlconverter.toClojureWarn,
    csharp: curlconverter.toCSharpWarn,
    dart: curlconverter.toDartWarn,
    elixir: curlconverter.toElixirWarn,
    go: curlconverter.toGoWarn,
    har: curlconverter.toHarStringWarn,
    httpie: curlconverter.toHttpieWarn,
    java: curlconverter.toJavaWarn,
    'java-httpurlconnection': curlconverter.toJavaHttpUrlConnectionWarn,
    'java-jsoup': curlconverter.toJavaJsoupWarn,
    'java-okhttp': curlconverter.toJavaOkHttpWarn,
    javascript: curlconverter.toJavaScriptWarn,
    'javascript-jquery': curlconverter.toJavaScriptJqueryWarn,
    'javascript-xhr': curlconverter.toJavaScriptXHRWarn,
    julia: curlconverter.toJuliaWarn,
    kotlin: curlconverter.toKotlinWarn,
    lua: curlconverter.toLuaWarn,
    matlab: curlconverter.toMATLABWarn,
    node: curlconverter.toNodeWarn,
    'node-http': curlconverter.toNodeHttpWarn,
    'node-axios': curlconverter.toNodeAxiosWarn,
    'node-got': curlconverter.toNodeGotWarn,
    'node-ky': curlconverter.toNodeKyWarn,
    'node-request': curlconverter.toNodeRequestWarn,
    'node-superagent': curlconverter.toNodeSuperAgentWarn,
    objc: curlconverter.toObjectiveCWarn,
    ocaml: curlconverter.toOCamlWarn,
    perl: curlconverter.toPerlWarn,
    php: curlconverter.toPhpWarn,
    'php-guzzle': curlconverter.toPhpGuzzleWarn,
    'php-requests': curlconverter.toPhpRequestsWarn,
    powershell: curlconverter.toPowershellRestMethodWarn,
    'powershell-webrequest': curlconverter.toPowershellWebRequestWarn,
    python: curlconverter.toPythonWarn,
    'python-http': curlconverter.toPythonHttpWarn,
    r: curlconverter.toRWarn,
    'r-httr2': curlconverter.toRHttr2Warn,
    ruby: curlconverter.toRubyWarn,
    'ruby-httparty': curlconverter.toRubyHttpartyWarn,
    rust: curlconverter.toRustWarn,
    swift: curlconverter.toSwiftWarn,
};

function normalizeCurlCommand(curlCode) {
    let command = curlCode || '';
    if (!command.trim()) {
        command = 'curl example.com';
    }
    if (/^\s*\$\s+curl\s+/m.test(command)) {
        command = command.replace(/^\s*\$\s*/, '');
    }
    if (command.startsWith('curl\u00A0')) {
        command = command.replace(/\u00A0/g, ' ');
    }
    return command;
}

function convert(curlCode, language) {
    const converter = CONVERTERS[language];
    if (!converter) {
        throw new Error('Unsupported language: ' + language);
    }

    const command = normalizeCurlCommand(curlCode);
    const warnings = [];
    const result = converter(command, warnings);
    let code = Array.isArray(result) ? result[0] : result;
    const resultWarnings = Array.isArray(result) && Array.isArray(result[1]) ? result[1] : warnings;

    if (typeof code === 'string' && code.endsWith('\n')) {
        code = code.slice(0, -1);
    }

    return {
        code: code || '',
        warnings: (resultWarnings || []).map(function (item) {
            return Array.isArray(item) ? item[1] : String(item);
        }),
        hljsLang: HLJS_LANG[language] || 'plaintext',
    };
}

window.CurlConverter = {
    convert: convert,
    languages: Object.keys(CONVERTERS),
};
